

namespace BasicLayout {

    function refreshIt(postUrl: string) {
        return () => {
            $.post(postUrl,
                {},
                data => {
                    for (let key in data) {
                        if (data.hasOwnProperty(key)) {
                            $(`input[name=${key}]`).val(data[key]);
                        }
                    }
                });
        }
    }

    function setupAntiDoubleClick() {
        $("form").on('submit', function (e) {
            var $form = $(this);

            if ($form.data('submitted') === true) {
                e.preventDefault();
                $("#waitModal").modal('show');
            } else {
                $form.data('submitted', true);

            }
        });
        return this;
    }

    function setupPleaseWaits() {
        $("form").after(
            "<div id='waitModal' class='modal fade'><div class='modal-dialog'><div class='modal-content'><div class='modal-body'>Please Wait</div></div></div></div>"
        );
    }

    function setupRefreshXsrf() {
        const items = $("[data-updatetok]");
        var set: { [key: string]: Boolean; } = {}
        items.each((i, ele) => {
            const key = $(ele).data("updatetok");
            if (key) {
                set[key] = true;
            }
        });
        for (let link in set) {
            if (set.hasOwnProperty(link)) {

                refreshIt(link)();
                setInterval(refreshIt(link),
                    300000); //5 miutes
            }
        }
    }

    function setupAspValidationToBootstrapValidation() {
        $('.input-validation-error').parents('.form-group').addClass('has-error');
        $('.field-validation-error').addClass('text-danger');
    }

    export function onReady() {
        setupPleaseWaits();
        setupRefreshXsrf();
        setupAntiDoubleClick();
        setupAspValidationToBootstrapValidation();
    }

}
$(BasicLayout.onReady);